import CalcHeader from "./CalcHeader";
import ChooseNumOfNums from "./ChooseNumNums";
import React, { useState, useEffect } from "react";
import CalcForm from "./CalcBody";
import "../main.css";
import { BASE_URL } from "../apiConfig";
function Calculator() {
  const [numSubmits, setNumSubmits] = useState(null);
  const [numFills, setNumFills] = useState(null);
  const [tftInfo, setTftInfo] = useState(null);

  useEffect(() => {
    async function initTireFillsAndSubmissions() {
        try {
          const submissions = await fetch(`${BASE_URL}/getTotalSubmissions`);
          const submissionsRes = await submissions.json();
          const tireFills = await fetch(`${BASE_URL}/tireFills`)
          const tireFillsRes = await tireFills.json();
          await Promise.all([tireFills, tireFillsRes]);
          setNumSubmits(submissionsRes.totalSubmissions);
          setNumFills(tireFillsRes.tireFills);

        } catch (err) {
          console.log("list subs", err);
          // throw err;
        }
    }

    initTireFillsAndSubmissions();
  }, []);

  const getTireFill = async (tireSize) => {
    //const getTireFill = async (tireSize, tireSize.notation) => {
    
      return await fetch(`${BASE_URL}/getTireFill`, {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        method: "POST",
        body: JSON.stringify(tireSize),
      });
    
  }

  const addTireSizeSubmit = async (vals, matchType) => {
    const res = await fetch(`${BASE_URL}/getMatchingSubmission`, {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      method: "POST",
      body: JSON.stringify({vals, matchType}),
    });
  };

  return (
    <div className="justify-content-center vertical-center">
      <ChooseNumOfNums setTftInfo={setTftInfo} tftInfo={tftInfo} />
      {tftInfo === null ? (
        <div></div>
      ) : (
        <CalcForm
          numSubmits={numSubmits}
          numFills={numFills}
          addTireSizeSubmit={addTireSizeSubmit}
          notation={tftInfo.notation}
          msrmtNames={tftInfo.msrmtNames}
          initValues={tftInfo.initValues}
          getTireFill={getTireFill}
        />
      )}
      {tftInfo === null ? <div></div> : <CalcHeader tftInfo={tftInfo} />}
    </div>
  );
}

export default Calculator;
